import type { FaireProductEntity } from "../../entity_types/product";

export const p_svcamt9d3f: FaireProductEntity = {
  token: "p_svcamt9d3f",
  type: "product",
  name: "Black Drawing Salve",
  brandToken: "b_3bx0gt904o",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8d2cee752c5554266e3f8c9634bd9402daaca47dca0192425f88b619f1b9177b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e4332fe05062100da9a2b0bcf60fa2c09ec441507c1353ea7a9793cba7f0e49.png",
    "https://cdn.faire.com/fastly/7cad259af7395b7e8fd3315c09e4a2072ce38eccd508b7cd5b26c1e382ae151a.png",
    "https://cdn.faire.com/fastly/388232d4aebe0dcd35aa262930d48162500d01157847e33d89ab2bffebf8bd1e.png",
    "https://cdn.faire.com/fastly/481163a1617f38944d95b76801c4d1ce0229f51d32c45d6decaa218fccdf3fc7.png",
  ],
  priceDollars: 6.24,
  description:
    "Black drawing salve - this is a highly requested product from many mommies. Our black drawing salve is perfect for those splinters and thorns embedded in your little ones' feet (or anywhere else)! Simply clean the boo-boo, dry it off, apply the salve, and cover it with a band-aid. Let it work its magic! Clay and charcoal work as drawing ingredients and the herbs, and essential oils help with healing.\n\nMade with avocado oil infused with comfrey, yarrow, plantain\nand calendula dried herbs, coconut oil, beeswax, raw honey, kaolin clay, activated charcoal, Oregon essential oil, Tea Tree essential oil.",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:31.678Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
